import React from 'react';

import { Flex } from 'common/components/Flex';
import { Grid, GridItem } from 'common/components/Grid';
import Separator from 'common/components/Separator';
import TrustSealsItem from './TrustSealsItem';
import type { TrustSeal } from './types';

interface TrustSealsProps {
  items: TrustSeal[];
}

const TrustSeals = ({ items }: TrustSealsProps) => (
  <Grid as="section" data-corgi-id="trust-seals">
    <GridItem>
      <Separator mb={[null, null, 'sp_24']} display={['none', null, 'block']} />
      <Flex
        data-testid="trust-seals"
        justifyContent="center"
        alignItems="center"
        flexDirection={['column', 'column', 'row']}
        px={['sp_8', 'sp_12', 'sp_0']}
        pt={['sp_16', 'sp_20', 'sp_0']}
        pb={['sp_16', 'sp_20', 'sp_24']}
      >
        {items.map((item, index) => (
          <TrustSealsItem key={index} {...item} />
        ))}
      </Flex>
    </GridItem>
  </Grid>
);

export default TrustSeals;
